import axios from "axios";
export default {
  namespaced: true,
  state: {
    warranty_policies: [],
  },
  getters: {
    warranty_policies(state) {
      return state.warranty_policies;
    },
  },
  mutations: {
    SET_WARRANTY_POLICIES(state, policies) {
      state.warranty_policies = policies;
    },
    ADD_WARRANTY_POLICY(state, policy) {
      state.warranty_policies.unshift(policy);
    },
    EDIT_WARRANTY_POLICY(state, policy) {
      var index = state.warranty_policies.findIndex((a) => a.id == policy.id);
      state.warranty_policies.splice(index, 1, policy);
    },
    DELETE_WARRANTY_POLICY(state, id) {
      state.warranty_policies = state.warranty_policies.filter(
        (p) => p.id != id
      );
    },
  },
  actions: {
    async get_warranty_policies({ commit }) {
      let response = await axios.get("/warranty_policies");
      commit("SET_WARRANTY_POLICIES", response.data);
    },
    async add_warranty_policy({ commit }, request) {
      let response = await axios.post("/warranty_policy", request);
      commit("ADD_WARRANTY_POLICY", response.data);
    },
    async edit_warranty_policy({ commit }, request) {
      let response = await axios.put("/warranty_policy", request);
      commit("EDIT_WARRANTY_POLICY", response.data);
    },
    async delete_warranty_policy({ commit }, id) {
      await axios.delete("/warranty_policy/" + id);
      commit("DELETE_WARRANTY_POLICY", id);
    },
  },
};
